import { createContext } from 'react';

export type ThemeMode = 'Dark' | 'Light';

export const ThemeModeContext = createContext<ThemeMode>('Dark');
